<template>
  <v-app>
    <v-main>
      <navbar/>
      <router-view/>
      <foot/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
